export function initChoicesConfig() {
	// ── Newsletter location: single-select sharing the site-wide Choices styling ──
	document.querySelectorAll('.js-newsletter-location').forEach(function (select) {
		if (!window.Choices || select._mowgliChoices) {
			return;
		}

		// Multi-select variant (disabled for now — re-enable by adding `multiple` to the select):
		// select._mowgliChoices = new Choices(select, {
		// 	removeItemButton: true,
		// 	shouldSort: false,
		// 	itemSelectText: '',
		// 	placeholder: true,
		// 	placeholderValue: select.getAttribute('data-placeholder') || 'Select location'
		// });

		select._mowgliChoices = new Choices(select, {
			searchEnabled: false,
			shouldSort: false,
			itemSelectText: ''
		});
	});

	// ── Gift-card amount selector: reuse the Choices styling used elsewhere ──
	document.querySelectorAll('.product-detail__cart .variations select').forEach(function (select) {
		if (!window.Choices || select._mowgliChoices) {
			return;
		}

		// select._mowgliChoices = new Choices(select, {
		// 	searchEnabled: false,
		// 	shouldSort: false,
		// 	itemSelectText: ''
		// });

		select._mowgliChoices = new Choices(select, {
			searchEnabled: false,
			shouldSort: false,
			itemSelectText: '',
			placeholder: true,
			placeholderValue: 'Choose an option'
		});

		// WooCommerce rewrites the select's options after every variation
		// check, leaving Choices  pointing at detached nodes
		// if (window.jQuery) {
		// 	window.jQuery(select).closest('form.variations_form').on('woocommerce_update_variation_values', function () {
		// 		select._mowgliChoices.setChoices(Array.prototype.map.call(select.options, function (option) {
		// 			return {
		// 				value: option.value,
		// 				label: option.textContent,
		// 				selected: option.selected,
		// 				disabled: option.disabled
		// 			};
		// 		}), 'value', 'label', true);
		// 	});
		// }

		if (window.jQuery) {
		window.jQuery(select)
			.closest('form.variations_form')
			.on('woocommerce_update_variation_values', function () {

				// TEMP: do nothing
			});

			console.log(
			[...select.options].map(o => ({
				value: o.value,
				text: o.text,
				selected: o.selected
			}))
		);
	}


		// reveal the custom-value box when the "Other" option is chosen
		var customBox = document.querySelector('.js-gift-card-custom-amount');
		function toggleCustomAmount() {
			if (!customBox) {
				return;
			}
			var option = select.options[select.selectedIndex];
			var isOther = !!option && /other/i.test(option.textContent);
			customBox.hidden = !isOther;
			if (!isOther) {
				var input = customBox.querySelector('input');
				if (input) {
					input.value = '';
				}
			}
		}

		// Choices dispatches a native change, but WooCommerce's variation form
		// binds through jQuery — re-fire it there so it finds the variation and
		// enables the Add to basket button
		var syncing = false;
		select.addEventListener('change', function () {
			if (syncing) {
				return;
			}
			var chosen = select._mowgliChoices.getValue(true);
			if (typeof chosen === 'string' && chosen !== '' && select.value !== chosen) {
				select.value = chosen;
			}
			toggleCustomAmount();
			if (!window.jQuery) {
				return;
			}
			syncing = true;
			window.jQuery(select).trigger('change');
			syncing = false;
		});

		toggleCustomAmount();
	});
}

// /GFORM FIX?
// function initGravityFormsChoices(root) {

//     var scope = root && root.querySelectorAll ? root : document;

//     scope.querySelectorAll('.gform_wrapper select').forEach(function (select) {

//         // Skip hidden fields and anything Choices has already enhanced
//         if (!window.Choices || select.offsetParent === null || select._mowgliChoices) return;

//         select._mowgliChoices = new Choices(select, {
//             searchEnabled: true,
//             itemSelectText: '',
//             shouldSort: false
//         });

//     });

// }

// document.addEventListener('DOMContentLoaded', function () {
//     initGravityFormsChoices(document);
// });

// // Gravity Forms rebuilds the form markup after AJAX submissions, pagination
// // and conditional logic, which destroys any existing Choices instances.
// // Re-initialise once GF signals that a form has finished (re)rendering.
// if (window.jQuery) {
//     window.jQuery(document).on('gform_post_render', function (event, formId) {
//         var form = document.getElementById('gform_wrapper_' + formId) ||
//                    (document.getElementById('gform_' + formId) &&
//                     document.getElementById('gform_' + formId).closest('.gform_wrapper'));
//         initGravityFormsChoices(form || document);
//     });
// }